
<!--PC-TABLETS VERSION-->
<div class="container justify-content-center d-none d-md-block pb-md-3">
  <div class="row w-100 text-center">
    <div class="col-md-12">
      <p class="filter-tittle">Conoce las promociones y beneficios que tenemos para ti</p>
    </div>
  </div>

  <div class="row">
    <div class="col-md-2">
      <img class="d-none d-lg-block" src="{{cardShadowed}}" width="150px" height="121px">
      <img class="d-none d-md-block d-lg-none" src="{{cardShadowed}}" width="100px" height="81px">
    </div>
    <div class="col-md-10">
      <div class="row">

        <div class="input-group col-md-5">
          <span class="input-group-append">
                <button class="btn btn-outline-secondary border-right-0 border rounded-left" type="button">
                    <i class="fa fa-search"></i>
                </button>
          </span>
          <input class="form-control py-2 border-left-0 border" [(ngModel)]="keyWord" type="search" placeholder="Encuentra una promoción"  id="keyword-input" style="font-family: 'Circular-Book', sans-serif; height: 39px" maxlength="64">

        </div>

        <div class="input-group col-md-5" style="cursor: pointer;" (click)="showNearByPromos()">
          <span class="input-group-append">
                <button class="btn btn-outline-secondary border-right-0 border rounded-left" type="button">
                    <i class="fa fa-map-marker"></i>
                </button>
          </span>
          <input class="form-control py-2 border-left-0 border nearby-input" type="search" placeholder="Promociones cerca de mí"  id="example-near-input" style="font-family: 'Circular-Book', sans-serif; height: 39px; cursor: pointer;">
        </div>

        <div class="col-md-2">
          <button type="submit" class="d-none d-lg-block button-search rounded w-75 text-center" (click)="filterOffers()">Buscar</button>
          <button type="submit" class="d-none d-md-block d-lg-none button-search rounded w-75 text-center" style="font-size: 13px" (click)="filterOffers()">Buscar</button>
        </div>

      </div>

      <div class="row pt-2">
        <div class="col-md-5">
<!--          <select class="form-select rounded-0" aria-label="Default select example" [(ngModel)]="selectedCategory" (ngModelChange)="onChangeCategory($event)" style="width: 98%">-->
          <select class="form-control rounded input-field-filter"  [(ngModel)]="selectedCategory" aria-label="Categoría">
            <option selected value="-1">Categoría</option>
            <option *ngFor="let category of categories" [value]="category.id">{{category.description}}</option>
          </select>
        </div>
        <div class="col-md-5">
          <select class="form-control rounded input-field-filter" [(ngModel)]="selectedState" aria-label="Estado">
            <option selected value="-1">Estados</option>
            <option *ngFor="let state of states" [value]="state.idEstado">{{state.descripcion}}</option>
          </select>
        </div>
        <div class="col-md-2">
          <button type="submit" (click)="cleanFilter()" class="d-none d-lg-block button-clean rounded w-75 text-center">Limpiar</button>
          <button type="submit" (click)="cleanFilter()" class="d-none d-md-block d-lg-none button-clean rounded w-75 text-center" style="font-size: 13px">Limpiar</button>
        </div>
      </div>

    </div>
  </div>

</div>
<!--PC-TABLETS VERSION ENDS-->

<!--MOBILE VERSION-->
<div class="container justify-content-center d-block d-md-none">
  <div class="row w-100 text-center">
    <div class="col-12">
      <p class="filter-tittle">Conoce las promociones y beneficios que tenemos para ti</p>
    </div>
  </div>

  <div class="row w-100 text-center ml-0">
    <div class="col-12">
      <img src="{{cardShadowed}}" width="150px" height="120px">
    </div>
  </div>

  <div class="row w-100 text-center ml-0">
    <div class="input-group col-12 w-100" style="cursor: pointer;" (click)="showNearByPromos()">
          <span class="input-group-append">
                <button class="btn btn-outline-secondary border-right-0 border rounded-left" type="button">
                    <i class="fa fa-map-marker"></i>
                </button>
          </span>
      <input class="form-control py-2 border-left-0 border nearby-input" type="search" placeholder="Promociones cerca de mí"  id="example-near-input" style="font-family: 'Circular-Book', sans-serif; height: 39px; cursor: pointer;">
    </div>
  </div>

  <div class="row w-100 text-center pt-1 ml-0">
      <div class="input-group col-12">
          <span class="input-group-append">
                <button class="btn btn-outline-secondary border-right-0 border rounded-left" type="button">
                    <i class="fa fa-search"></i>
                </button>
          </span>
        <input class="form-control py-2 border-left-0 border" [(ngModel)]="keyWordMobile" type="search" placeholder="Encuentra una promoción"  id="keyword-input" style="font-family: 'Circular-Book', sans-serif; height: 39px" maxlength="64">
      </div>
  </div>

  <div class="row w-100 pt-1 ml-0">
    <div class="col-12">
      <!--          <select class="form-select rounded-0" aria-label="Default select example" [(ngModel)]="selectedCategory" (ngModelChange)="onChangeCategory($event)" style="width: 98%">-->
      <select class="form-control rounded"  [(ngModel)]="selectedCategoryMobile" aria-label="Categoría">
        <option selected value="-1">Categoría</option>
        <option *ngFor="let category of categories" [value]="category.id">{{category.description}}</option>
      </select>
    </div>
  </div>

  <div class="row w-100 pt-1 ml-0">
    <div class="col-12">
      <select class="form-control rounded" [(ngModel)]="selectedStateMobile" aria-label="Estado">
        <option selected value="-1">Estados</option>
        <option *ngFor="let state of states" [value]="state.idEstado">{{state.descripcion}}</option>
      </select>
    </div>
  </div>

  <div class="row w-100 pt-3 pb-3 ml-0">
    <div class="col-12 justify-content-center">
      <div class="row ml-2">
        <div class="col-6 w-100">
          <button type="submit" class="button-search rounded w-75 text-center" (click)="filterOffersMobile()">Buscar</button>
        </div>
        <div class="col-6">
          <button type="submit" (click)="cleanFilterMobile()" class="button-clean rounded w-75 text-center">Limpiar</button>
        </div>
      </div>
    </div>
  </div>

</div>
<!--MOBILE VERSION ENDS-->
